import { baseApi } from "../baseApi";

export const contactapi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGenderOptions: builder.query({
      query: () => ({
        url: `/api/resource/Gender`,
        method: 'GET'
      })
    }),

    getUserOptions: builder.query({
      query: () => ({
        url: `/api/resource/User`,
        method: 'GET'
      })
    }),

    getSalutationOptions: builder.query({
      query: () => ({
        url: `/api/resource/Salutation`,
        method: 'GET'
      })
    }),

    getDocTypeOptions: builder.query({
      query: () => ({
        url: `/api/resource/DocType`,
        method: 'GET'
      })
    }),
    getResource: builder.query({
      query: (resourceName: string) => ({
        url: `/api/resource/${resourceName}`,
        method: 'GET'
      })
    }),
    createContact: builder.mutation({
    query: (body) => ({
      url: `/api/resource/Contact`,
      method: 'POST',
      body,
    }),
  }),

getContacts: builder.query({
  query: () => {
    const fieldsArray = [
      "`tabContact`.`name`",
      "`tabContact`.`owner`",
      "`tabContact`.`creation`",
      "`tabContact`.`modified`",
      "`tabContact`.`modified_by`",
      "`tabContact`.`_user_tags`",
      "`tabContact`.`_comments`",
      "`tabContact`.`_assign`",
      "`tabContact`.`_liked_by`",
      "`tabContact`.`docstatus`",
      "`tabContact`.`idx`",
      "`tabContact`.`email_id`",
      "`tabContact`.`status`",
      "`tabContact`.`phone`",
      "`tabContact`.`full_name`",
      "`tabContact`.`image`"
    ]
    
    const fields = JSON.stringify(fieldsArray);

    return {
      url: `/api/resource/Contact`,
      method: 'GET',
      params: {
        fields,
        limit_page_length: 0,   
      }
    }
  }
}),

getContactByName: builder.query({
      query: (contactName: string) => ({
        url: `/api/resource/Contact/${encodeURIComponent(contactName)}`,
        method: 'GET'
      }),
      // You can add transformResponse if you need to modify the data
      transformResponse: (response: any) => {
        return response.data;
      }
    }),

  }),
});

export const { 
useGetGenderOptionsQuery, 
  useGetUserOptionsQuery, 
  useGetSalutationOptionsQuery, 
  useGetDocTypeOptionsQuery,
  useLazyGetResourceQuery ,
  useCreateContactMutation,
  useGetContactsQuery,
  useGetContactByNameQuery ,
  useLazyGetContactByNameQuery  
} = contactapi;
